import { getLocale } from '@libs/constants';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

export interface AddToEchainModalContentProps {
  sku: string;
}

export const AddToEchainModalContent = ({ sku }: AddToEchainModalContentProps) => {
  const router = useRouter();
  const locale = getLocale(router);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const hideExternalCloseButton = () => {
      const iframe = iframeRef.current;
      if (iframe?.contentWindow?.document) {
        const externalCloseButton = iframe.contentWindow.document.querySelector('#cablePoolClose');
        if (externalCloseButton) {
          (externalCloseButton as HTMLButtonElement).style.display = 'none';
        }
      }
    };

    iframeRef.current?.addEventListener('load', hideExternalCloseButton);
    return () => {
      iframeRef?.current?.removeEventListener('load', hideExternalCloseButton);
    };
  }, [sku, locale]);

  return (
    <iframe
      ref={iframeRef}
      data-testid="add-to-echain-config-iframe"
      src={EXTERNAL_LINKS.ADD_TO_ECHAIN_CONFIG(sku, locale)}
      style={{ border: 'medium none', padding: 0, margin: 0, width: 454, height: 267 }}
      scrolling="no"
      frameBorder="0"
    />
  );
};
